import { createFileRoute, redirect } from '@tanstack/react-router';

import { paths } from 'src/routes/paths';

export const Route = createFileRoute('/_authed/dashboard/o/$orgId/settings/')({
  beforeLoad: ({ params }) => {
    // Redirect to the default settings page (brand profile)
    throw redirect({
      to: paths.dashboard.orgSettings(params.orgId).client.brand,
    });
  },
});
